import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotLanguage } from './languages.abstraction';

@Injectable({ providedIn: 'root' })
export class LanguagesApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getLanguages(): Observable<ListResponse<BotLanguage>> {
    return this._httpClient.get<ListResponse<BotLanguage>>('@api/settings/intl/locales/').pipe(
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
